import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { INDUSTRY_REPORT_CATEGORY } from 'src/app/shared/constants/common-constants';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { TansactionService } from 'src/app/shared/services/node-api/tansaction.service';

@Component({
  selector: 'app-micro-product-list-page',
  templateUrl: './micro-product-list-page.component.html',
  styleUrls: ['./micro-product-list-page.component.scss']
})
export class MicroProductListPageComponent implements OnInit {
  @Input() industry_list;
  @Input() totalRecords = 0;
  isPremium = false;
  plan: any;
  isAdvance = false;
  isFree = false;
  microform: UntypedFormGroup;
  token: any = undefined;
  loginEmail: any;
  industryReportCategory = INDUSTRY_REPORT_CATEGORY;

  constructor(
    private localStorageService: LocalStorageService,
    private toastService: ToastService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private router: Router,
    private tansactionService:TansactionService,
    private loginSignupService:LoginSignupService
  ) {}

  ngOnInit(): void {
    this.loginEmail = this.loginSignupService.getUserSession()?.user?.name;
    this.plan = this.localStorageService.getItem('plan');
    if (this.plan === 'plan_advance') {
      this.isAdvance = true;
    } else if (this.plan === 'plan_premium') {
      this.isPremium = true;
    } else {
      this.isFree = true;
    }

    // this.getIndustryReport();
    this.recaptchaV3Service
      .execute('customerReportRequest')
      .subscribe((token: string) => {
        this.token = token;
      });
  }

  navigateToDetailsPage(product){
    this.router.navigate([`/reports/details/${product.report_url}`]);
  }

  getLabelByCode(code: string): string {
    const category = this.industryReportCategory.find(item => item.code === code);
    return category ? category.label : 'Unknown';
  }

   addToCart(product) {
      if (
        this.loginEmail == undefined ||
        this.loginEmail == '' ||
        this.loginEmail == null
      ) {
        this.localStorageService.setItem("redirect_url",this.router.url);
        this.router.navigate(['/user/login']);
      } else {
        let currentOption;
        currentOption = {
          sku: product.sku,
        };
        this.tansactionService.addProductToCart(currentOption).then(
          (data: any) => {
              this.toastService.addSingle(
                'success',
                'Item added to cart',
                'Make payment to complete this transaction.'
              );
          },
          (err) => {
            this.toastService.addSingle('error', 'Error', err.error.message);
          }
        );
      }
  }
}
